import type { TranscriptBreakdown, TranscriptFile } from '@teachur/http-client';

export const processedTranscriptIdFor = (
  file: TranscriptFile,
  transcripts: TranscriptBreakdown[]
): number | null => {
  if (file.processedTranscriptId != null) return file.processedTranscriptId;
  for (const transcript of transcripts) {
    for (const attached of transcript.files ?? []) {
      if (attached.kind !== 'legacy' && attached.fileId === file.fileId) {
        return transcript.id;
      }
    }
  }
  return null;
};

/**
 * Whether a legacy document has already been extracted. `processedAt` is the
 * durable signal — it is set once at process time and survives deletion of the
 * generated transcript (which `SET NULL`s `processedTranscriptId`). The
 * transcript-based fallbacks cover older rows that predate the flag.
 */
const isLegacyFileProcessed = (file: TranscriptFile, transcripts: TranscriptBreakdown[]): boolean =>
  file.processedAt != null || processedTranscriptIdFor(file, transcripts) != null;

/**
 * The legacy documents still available for extraction. Once processed a
 * document drops out of Old Platform Documents permanently — deleting the
 * generated transcript does not bring it back, and it cannot be extracted
 * again (the backend enforces the same rule).
 */
export const unprocessedLegacyFiles = (
  files: TranscriptFile[],
  transcripts: TranscriptBreakdown[]
): TranscriptFile[] => files.filter((f) => !isLegacyFileProcessed(f, transcripts));
